import React from 'react';
import { Button } from '../../../../components';
import { Footer } from './styles';
import { Container, SubTitle, Title } from './styles';

type EmptyListProps = {
  visible: boolean;
  searchInputText: string;
  emptyListFirstButton: (() => void) | null;
  emptyListSecondButton: (() => void) | null;
};

const CALL_CENTER_NUMBER = '(11) 2151-1233';

export const EmptyList: React.FC<EmptyListProps> = ({
  visible,
  searchInputText,
  emptyListFirstButton,
  emptyListSecondButton
}) => {
  return (
    <>
      {visible && (
        <>
          <Container>
            <Title>Nenhum resultado para "{searchInputText}".</Title>

            <SubTitle>Agende com outro profissional ou selecione o pagamento particular.</SubTitle>

            <SubTitle>
              Se preferir, entre em contato com a nossa Central de Atendimento pelo telefone{' '}
              <Title>{CALL_CENTER_NUMBER}</Title>
            </SubTitle>
          </Container>
          <Footer>
            {emptyListFirstButton && (
              <Button onClick={() => emptyListFirstButton()} title="Selecionar pagamento particular" type="button" />
            )}
            {emptyListSecondButton && (
              <Button
                onClick={() => emptyListSecondButton()}
                secondary
                title="Agendar com outro profissional"
                type="button"
              />
            )}
          </Footer>
        </>
      )}
    </>
  );
};
